var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from 'styled-components';
var VerticalFlex = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  flex-flow: column;\n  height: 100%;\n  /* height: -moz-available; */\n  /* height: -webkit-fill-available; */\n  /* height: fill-available;\n  height: stretch; */\n"], ["\n  display: flex;\n  flex-direction: column;\n  flex-flow: column;\n  height: 100%;\n  /* height: -moz-available; */\n  /* height: -webkit-fill-available; */\n  /* height: fill-available;\n  height: stretch; */\n"])));
/** @component */
export default VerticalFlex;
var templateObject_1;
